export default __webpack_public_path__ + "static/media/manager.74edf219.svg";